// ROTY FOOD — Structură de date pentru meniul digital.
// Editează produsele direct în acest fișier. UI-ul se generează automat.
// Câmpuri produs: category, subcategory, group, name, description,
// price, weight, volume, flavors, image, allergens, nutrition, available.
// Câmpuri pregătite pentru product details (opționale, momentan absente/null):
//   ingredients (string), additives (string[]), allergens (string[]),
//   nutrition = { per100g: {calorii, proteine, carbohidrati, grasimi},
//                 portion: {calorii, proteine, carbohidrati, grasimi} }  (null momentan)
// NOTĂ: prețuri MÂNCARE + DESERT = date REALE furnizate de client (iun. 2026).
//       Prețurile din pozele demo/vechi au fost ignorate complet.
//       Fotografiile reale (image) se adaugă ulterior, câte una per produs,
//       optimizate automat în WebP (variante responsive 200/400/800/1200).

export const RESTAURANT = {
  name: "ROTY FOOD",
  tagline: "Pizza & Coffee",
  phone: "0761 115 893",
  location: "Suceava",
};

// Structura de navigare (secțiuni și subcategorii)
export const SECTIONS = [
  {
    id: "mancare",
    label: "MÂNCARE",
    subcategories: [
      { id: "pizza", label: "PIZZA" },
      { id: "burgeri", label: "BURGERI & SANDVIȘURI" },
      { id: "crispy", label: "CRISPY & FRIED" },
      { id: "mici", label: "MICI & PREPARATE" },
      { id: "platouri", label: "PLATOURI" },
      { id: "garnituri", label: "GARNITURI" },
    ],
  },
  {
    id: "bauturi",
    label: "BĂUTURI",
    subcategories: [
      { id: "racoritoare", label: "RĂCORITOARE" },
      { id: "bere", label: "BERE" },
      { id: "coffee", label: "COFFEE" },
      { id: "limonade", label: "LIMONADE & FRESH" },
      { id: "alcoolice", label: "BĂUTURI ALCOOLICE" },
      { id: "vin", label: "VIN" },
      { id: "sampanie", label: "ȘAMPANIE" },
    ],
  },
  { id: "desert", label: "DESERT", subcategories: [] },
  { id: "extra", label: "EXTRA", subcategories: [] },
];

// ————————————————————————————————————————————
// PRODUSE
// ————————————————————————————————————————————
// Produsele de mâncare & desert: date REALE din meniul actual ROTY (iun. 2026).
// Ingredientele afișate provin din meniul furnizat. additives/allergens/
// nutritionPer100g/nutritionPerServing rămân goale până la fișele oficiale
// (nu inventa nimic). Fiecare produs are image: null pregătit pentru foto reală.

export const PRODUCTS = [
  // ——— MÂNCARE / PIZZA ———  (foto reală per produs se adaugă ulterior)
  {
    category: "mancare", subcategory: "pizza", name: "Pizza Capriciosa", price: 36, weight: "32 cm · 600 g", weightGrams: 600,
    ingredients: "Aluat, mozzarella, salam, sos de roșii, cabanos, ceapă, ardei, roșii, măsline, ciuperci",
    additives: ["Acid citric (E330)", "Nitrit de sodiu (E250)", "Glicozide de steviol (E960)"],
    allergens: ["Gluten", "Lapte"], traces: ["Gluten", "Lapte", "Muștar", "Soia"],
    nutritionPer100g: { kcal: 241.6, proteine: 11.2, grasimi: 15.8, saturate: 6.4, glucide: 15, zaharuri: 0.8, sare: 1.1 },
    nutritionPerServing: { kcal: 1449.6, proteine: 67.2, grasimi: 94.8, saturate: 38.4, glucide: 90, zaharuri: 4.8, sare: 6.6 },
    image: "pizza-hero", available: true,
  },
  {
    category: "mancare", subcategory: "pizza", name: "Pizza Quatro Stagioni", price: 34, weight: "32 cm · 600 g", weightGrams: 600,
    ingredients: "Aluat, mozzarella, șuncă, sos de roșii, ardei, ciuperci, măsline",
    additives: ["Acid citric (E330)", "Lactat de sodiu (E325)", "Ascorbat de sodiu (E301)", "Trifosfați (E451)", "Caragenan (E407)", "Nitrit de sodiu (E250)"],
    allergens: ["Gluten", "Lapte", "Soia"], traces: ["Gluten", "Lapte"],
    nutritionPer100g: { kcal: 184.1, proteine: 9.2, grasimi: 9.5, saturate: 4.3, glucide: 16.4, zaharuri: 0.8, sare: 0.9 },
    nutritionPerServing: { kcal: 1104.6, proteine: 55.2, grasimi: 57, saturate: 25.8, glucide: 98.4, zaharuri: 4.8, sare: 5.4 },
    image: "pizza-quatro-stagioni", available: true,
  },
  {
    category: "mancare", subcategory: "pizza", name: "Pizza cu Pui", price: 36, weight: "32 cm · 600 g", weightGrams: 600,
    ingredients: "Aluat, mozzarella, șuncă, piept de pui, sos de roșii, roșii, ardei, ciuperci",
    additives: ["Acid citric (E330)", "Lactat de sodiu (E325)", "Ascorbat de sodiu (E301)", "Trifosfați (E451)", "Caragenan (E407)", "Nitrit de sodiu (E250)"],
    allergens: ["Gluten", "Lapte", "Soia"], traces: ["Gluten", "Lapte"],
    nutritionPer100g: { kcal: 176.5, proteine: 11.7, grasimi: 8.4, saturate: 3.8, glucide: 14.3, zaharuri: 0.8, sare: 0.8 },
    nutritionPerServing: { kcal: 1059, proteine: 70.2, grasimi: 50.4, saturate: 22.8, glucide: 85.8, zaharuri: 4.8, sare: 4.8 },
    image: "pizza-pui", available: true,
  },
  {
    category: "mancare", subcategory: "pizza", name: "Pizza cu Ton", price: 36, weight: "32 cm · 600 g", weightGrams: 600,
    ingredients: "Aluat, mozzarella, ton, porumb, sos de roșii, roșii, măsline, ceapă",
    additives: ["Acid citric (E330)"],
    allergens: ["Gluten", "Pește", "Lapte"], traces: ["Gluten"],
    nutritionPer100g: { kcal: 178.6, proteine: 9.4, grasimi: 9, saturate: 4, glucide: 16.2, zaharuri: 0.9, sare: 0.8 },
    nutritionPerServing: { kcal: 1071.6, proteine: 56.4, grasimi: 54, saturate: 24, glucide: 97.2, zaharuri: 5.4, sare: 4.8 },
    image: "pizza-ton", available: true,
  },
  {
    category: "mancare", subcategory: "pizza", name: "Pizza Margherita", price: 32, weight: "32 cm · 500 g", weightGrams: 500,
    ingredients: "Sos roșii, oregano, mozzarella",
    additives: [], allergens: [],
    nutritionPer100g: { kcal: 245, proteine: 10, grasimi: 9.5, saturate: null, glucide: 29.5, zaharuri: null, sare: 1 },
    nutritionPerServing: { kcal: 1225, proteine: 50, grasimi: 47.5, saturate: null, glucide: 147.5, zaharuri: null, sare: 5 },
    image: "pizza-margherita", available: true,
  },
  {
    category: "mancare", subcategory: "pizza", name: "Pizza Rustica", price: 36, weight: "32 cm · 600 g", weightGrams: 600,
    ingredients: "Aluat, mozzarella, bacon de porc, cabanos, telemea, sos de roșii, ceapă",
    additives: ["Acid citric (E330)"],
    allergens: ["Gluten", "Lapte"], traces: ["Gluten"],
    nutritionPer100g: { kcal: 259.7, proteine: 11.3, grasimi: 18.1, saturate: 7, glucide: 14.3, zaharuri: 0.6, sare: 0.9 },
    nutritionPerServing: { kcal: 1558.2, proteine: 67.8, grasimi: 108.6, saturate: 42, glucide: 85.8, zaharuri: 3.6, sare: 5.4 },
    image: "pizza-rustica", available: true,
  },
  {
    category: "mancare", subcategory: "pizza", name: "Pizza Vegetală", price: 34, weight: "32 cm · 600 g", weightGrams: 600,
    ingredients: "Aluat, mozzarella, roșii, ardei, măsline, ciuperci, porumb, sos de roșii, ceapă",
    additives: ["Acid citric (E330)"],
    allergens: ["Gluten", "Lapte"], traces: ["Gluten"],
    nutritionPer100g: { kcal: 168.5, proteine: 6.7, grasimi: 9, saturate: 4, glucide: 16.6, zaharuri: 1.2, sare: 0.6 },
    nutritionPerServing: { kcal: 1011, proteine: 40.2, grasimi: 54, saturate: 24, glucide: 99.6, zaharuri: 7.2, sare: 3.6 },
    postOnly: true, image: "pizza-vegetala", available: true,
  },
  {
    category: "mancare", subcategory: "pizza", name: "Pizza Family", price: 70, weight: "40 cm · 900 g",
    ingredients: "Orice model de pizza de mai sus",
    additives: [], allergens: [], nutritionPer100g: null, nutritionPerServing: null, image: null, available: true,
  },

  // ——— MÂNCARE / BURGERI & SANDVIȘURI ———
  {
    category: "mancare", subcategory: "burgeri", group: "Burgeri", name: "Meniu Burger House", price: 42, weight: "680 g", weightGrams: 680,
    ingredients: "Cartofi pai, carne tocată de vită, chiflă, roșii, salată, bacon de porc, maioneză, ketchup dulce, castraveți murați, cheddar, ceapă, cașcaval",
    additives: ["Acid citric (E330)", "Sorbat de potasiu (E202)", "Benzoat de sodiu (E211)", "Clorură de calciu (E509)"],
    allergens: ["Gluten", "Ouă", "Lapte", "Muștar"], traces: [],
    nutritionPer100g: { kcal: 230.9, proteine: 7.4, grasimi: 15.7, saturate: 2.4, glucide: 21.8, zaharuri: 1.8, sare: 0.8 },
    nutritionPerServing: { kcal: 1570.1, proteine: 50.3, grasimi: 106.8, saturate: 16.3, glucide: 148.2, zaharuri: 12.2, sare: 5.4 },
    image: "burger-house", available: true,
  },
  {
    category: "mancare", subcategory: "burgeri", group: "Burgeri", name: "Meniu Burger Șnițel", price: 40, weight: "650 g", weightGrams: 650,
    ingredients: "Cartofi pai, șnițel, chiflă, roșii, salată, cașcaval, ketchup dulce, maioneză, castraveți murați",
    additives: ["Acid citric (E330)", "Sorbat de potasiu (E202)", "Benzoat de sodiu (E211)", "Clorură de calciu (E509)"],
    allergens: ["Gluten", "Ouă", "Lapte", "Muștar"], traces: ["Gluten", "Ouă"],
    nutritionPer100g: { kcal: 197.7, proteine: 6.7, grasimi: 12.1, saturate: 2.2, glucide: 25.2, zaharuri: 2.6, sare: 1 },
    nutritionPerServing: { kcal: 1285, proteine: 43.6, grasimi: 78.6, saturate: 14.3, glucide: 163.8, zaharuri: 16.9, sare: 6.5 },
    image: "burger-house", available: true,
  },
  {
    category: "mancare", subcategory: "burgeri", group: "Burgeri", name: "Meniu Burger Vegetal", price: 40, weight: "650 g", weightGrams: 650,
    ingredients: "Vegetal, cartofi pai, chiflă, roșii, salată, cașcaval, ketchup dulce, maioneză, castraveți murați",
    additives: ["Acid citric (E330)", "Sorbat de potasiu (E202)", "Benzoat de sodiu (E211)", "Clorură de calciu (E509)"],
    allergens: ["Gluten", "Ouă", "Lapte", "Muștar"], traces: [],
    nutritionPer100g: { kcal: 192.9, proteine: 8.8, grasimi: 10.2, saturate: 2, glucide: 21.5, zaharuri: 2.4, sare: 1 },
    nutritionPerServing: { kcal: 1253.9, proteine: 57.2, grasimi: 66.3, saturate: 13, glucide: 139.8, zaharuri: 15.6, sare: 6.5 },
    postOnly: true, image: null, available: true,
  },
  {
    category: "mancare", subcategory: "burgeri", group: "Sandvișuri", name: "Sandwich", price: 22, weight: "305 g", weightGrams: 305,
    flavors: "crispy / salam / șuncă / șnițel",
    ingredients: "Chiflă, salam, castraveți murați, roșii, brânză tartinabilă, salată, cheddar, ketchup dulce, maioneză",
    additives: ["Nitrit de sodiu (E250)", "Sorbat de potasiu (E202)", "Benzoat de sodiu (E211)", "Glicozide de steviol (E960)", "Clorură de calciu (E509)", "Polifosfat de sodiu (E452i)", "Citrat monosodic (E331i)", "Fosfat de sodiu (E339)", "Acid citric (E330)"],
    allergens: ["Gluten", "Ouă", "Lapte", "Muștar"], traces: ["Lapte", "Muștar", "Soia"],
    nutritionPer100g: { kcal: 185.4, proteine: 11.2, grasimi: 15.9, saturate: 6.6, glucide: 23.3, zaharuri: 3.6, sare: 1.7 },
    nutritionPerServing: { kcal: 565.5, proteine: 34.2, grasimi: 48.5, saturate: 20.1, glucide: 71.1, zaharuri: 11, sare: 5.2 },
    image: "sandwich", available: true,
  },
  {
    category: "mancare", subcategory: "burgeri", group: "Sandvișuri", name: "Sandwich vegetal", price: 22,
    additives: [], allergens: [], nutritionPer100g: null, nutritionPerServing: null, postOnly: true, image: null, available: true,
  },

  // ——— MÂNCARE / CRISPY & FRIED ———
  {
    category: "mancare", subcategory: "crispy", name: "Meniu Nuggets", price: 30, weight: "500 g", weightGrams: 500,
    ingredients: "Cartofi pai, nuggets pui, maioneză",
    additives: [], allergens: ["Gluten", "Ouă"], traces: ["Gluten", "Ouă"],
    nutritionPer100g: { kcal: 319.4, proteine: 7.6, grasimi: 20.8, saturate: 2.2, glucide: 26.2, zaharuri: 0.4, sare: 1 },
    nutritionPerServing: { kcal: 1597, proteine: 38, grasimi: 104, saturate: 11, glucide: 131, zaharuri: 2, sare: 5 },
    image: "nuggets", available: true,
  },
  {
    category: "mancare", subcategory: "crispy", name: "Meniu Crispy Classic", price: 33, weight: "500 g", weightGrams: 500,
    ingredients: "Cartofi pai, crispy, sos de usturoi cu pătrunjel",
    additives: [], allergens: ["Gluten", "Ouă"], traces: ["Gluten", "Ouă"],
    nutritionPer100g: { kcal: 264.1, proteine: 7.3, grasimi: 12.9, saturate: 0.4, glucide: 31.5, zaharuri: 0.4, sare: 1 },
    nutritionPerServing: { kcal: 1320.5, proteine: 36.5, grasimi: 64.5, saturate: 2, glucide: 157.5, zaharuri: 2, sare: 5 },
    image: "crispy-classic", available: true,
  },
  {
    category: "mancare", subcategory: "crispy", name: "Meniu Crispy cu Susan", price: 35, weight: "500 g", weightGrams: 500,
    ingredients: "Cartofi pai, crispy, maioneză",
    additives: [], allergens: ["Gluten", "Ouă"], traces: ["Gluten", "Ouă"],
    nutritionPer100g: { kcal: 321.8, proteine: 6.8, grasimi: 19.2, saturate: 1.4, glucide: 30.6, zaharuri: 0.4, sare: 1 },
    nutritionPerServing: { kcal: 1609, proteine: 34, grasimi: 96, saturate: 7, glucide: 153, zaharuri: 2, sare: 5 },
    image: "crispy-susan", available: true,
  },
  {
    category: "mancare", subcategory: "crispy", name: "Meniu Aripioare Picante", price: 30, weight: "500 g", weightGrams: 500,
    ingredients: "Cartofi pai, aripioare de pui, ketchup dulce",
    additives: ["Acid citric (E330)", "Sorbat de potasiu (E202)", "Benzoat de sodiu (E211)"],
    allergens: ["Lapte"], traces: [],
    nutritionPer100g: { kcal: 245.2, proteine: 9, grasimi: 13.8, saturate: 1.4, glucide: 21.3, zaharuri: 1.7, sare: 1 },
    nutritionPerServing: { kcal: 1226, proteine: 45, grasimi: 69, saturate: 7, glucide: 106.5, zaharuri: 8.5, sare: 5 },
    image: "aripioare-picante", available: true,
  },
  {
    category: "mancare", subcategory: "crispy", name: "Meniu Nuggets de Post", price: 32, weight: "450 g", weightGrams: 450,
    ingredients: "Cartofi pai, nuggets vegetal, ketchup dulce",
    additives: ["Acid citric (E330)", "Sorbat de potasiu (E202)", "Benzoat de sodiu (E211)"],
    allergens: ["Gluten", "Lapte"], traces: ["Gluten"],
    nutritionPer100g: { kcal: 284, proteine: 5.7, grasimi: 15.1, saturate: 0.7, glucide: 31.1, zaharuri: 2.2, sare: 1.1 },
    nutritionPerServing: { kcal: 1278, proteine: 25.7, grasimi: 68, saturate: 3.1, glucide: 140, zaharuri: 9.9, sare: 5 },
    postOnly: true, image: "nuggets-post", available: true,
  },
  {
    category: "mancare", subcategory: "crispy", name: "Meniu Șnițel Pui", price: 30, weight: "500 g", weightGrams: 500,
    ingredients: "Cartofi pai, șnițel, ketchup dulce",
    additives: ["Acid citric (E330)", "Sorbat de potasiu (E202)", "Benzoat de sodiu (E211)"],
    allergens: ["Gluten", "Ouă", "Lapte"], traces: ["Gluten", "Ouă"],
    nutritionPer100g: { kcal: 270.7, proteine: 6.9, grasimi: 12.5, saturate: 0.4, glucide: 32.7, zaharuri: 2.1, sare: 1.1 },
    nutritionPerServing: { kcal: 1353.5, proteine: 34.5, grasimi: 62.5, saturate: 2, glucide: 163.5, zaharuri: 10.5, sare: 5.5 },
    image: "snitel-pui", available: true,
  },
  {
    category: "mancare", subcategory: "crispy", name: "Meniu Cașcaval Pane", price: 30, weight: "500 g", weightGrams: 500,
    ingredients: "Cartofi pai, cașcaval pane, maioneză",
    additives: [], allergens: ["Gluten", "Ouă", "Lapte"], traces: ["Gluten", "Ouă", "Lapte"],
    nutritionPer100g: { kcal: 339, proteine: 7.2, grasimi: 21.6, saturate: 3.4, glucide: 29, zaharuri: 0.8, sare: 1 },
    nutritionPerServing: { kcal: 1695, proteine: 36, grasimi: 108, saturate: 17, glucide: 145, zaharuri: 4, sare: 5 },
    image: "cascaval-pane", available: true,
  },

  // ——— MÂNCARE / MICI & PREPARATE ———
  {
    category: "mancare", subcategory: "mici", name: "Meniu Cârnăciori", price: 26, weight: "530 g", weightGrams: 530,
    ingredients: "Cartofi pai, cârnat, chiflă, muștar",
    additives: ["Gumă xantan (E415)", "Caroten (E160a)"],
    allergens: ["Gluten", "Ouă", "Lapte", "Muștar"], traces: ["Gluten"],
    nutritionPer100g: { kcal: 264.5, proteine: 8.2, grasimi: 17.4, saturate: 0.4, glucide: 24, zaharuri: 0.9, sare: 1.2 },
    nutritionPerServing: { kcal: 1401.8, proteine: 43.5, grasimi: 92.2, saturate: 2.1, glucide: 127.2, zaharuri: 4.8, sare: 6.4 },
    image: "carnaciori", available: true,
  },
  {
    category: "mancare", subcategory: "mici", name: "Meniu Mici", price: 28, weight: "560 g", weightGrams: 560,
    ingredients: "Cartofi pai, mici, chiflă, muștar",
    additives: ["Gumă xantan (E415)", "Caroten (E160a)"],
    allergens: ["Gluten", "Ouă", "Lapte", "Muștar"], traces: ["Gluten"],
    nutritionPer100g: { kcal: 222.6, proteine: 8.5, grasimi: 13.1, saturate: 2.5, glucide: 22.9, zaharuri: 0.9, sare: 1.5 },
    nutritionPerServing: { kcal: 1246.6, proteine: 47.6, grasimi: 73.4, saturate: 14, glucide: 128.2, zaharuri: 5, sare: 8.4 },
    image: "mici", available: true,
  },
  {
    category: "mancare", subcategory: "mici", name: "Meniu Chiftele de Post", price: 32, weight: "500 g", weightGrams: 500,
    ingredients: "Cartofi pai, chiftele vegetale, ketchup dulce",
    additives: ["Acid citric (E330)", "Sorbat de potasiu (E202)", "Benzoat de sodiu (E211)"],
    allergens: ["Gluten", "Lapte"], traces: ["Gluten"],
    nutritionPer100g: { kcal: 266.3, proteine: 6.5, grasimi: 9.3, saturate: 0, glucide: 27.9, zaharuri: 2.1, sare: 1.1 },
    nutritionPerServing: { kcal: 1331.5, proteine: 32.5, grasimi: 46.5, saturate: 0, glucide: 139.5, zaharuri: 10.5, sare: 5.5 },
    postOnly: true, image: "chiftele-post", available: true,
  },
  { category: "mancare", subcategory: "mici", name: "Meniu Rulouri de Post", price: 28, weight: "500 g", ingredients: "Cartofi pai, rulouri de post, sos", additives: [], allergens: [], nutritionPer100g: null, nutritionPerServing: null, postOnly: true, image: "rulouri-post", available: true },

  // ——— MÂNCARE / PLATOURI ———
  {
    category: "mancare", subcategory: "platouri", name: "Platou Grătar", price: 240, weight: "2,5 kg", weightGrams: 2500,
    ingredients: "Cartofi pai, cartofi țărănești, mici, cârnat, aripioare de pui, cașcaval pane, castraveți murați, chiflă, ketchup dulce, maioneză, muștar de masă",
    additives: ["Clorură de calciu (E509)", "Acid citric (E330)", "Sorbat de potasiu (E202)", "Benzoat de sodiu (E211)", "Gumă xantan (E415)", "Caroten (E160a)"],
    allergens: ["Gluten", "Ouă", "Lapte", "Muștar"], traces: ["Gluten", "Ouă", "Lapte"],
    nutritionPer100g: { kcal: 215.8, proteine: 8.3, grasimi: 13.5, saturate: 2.1, glucide: 17.8, zaharuri: 1.1, sare: 0.9 },
    nutritionPerServing: { kcal: 5395, proteine: 207.5, grasimi: 337.5, saturate: 52.5, glucide: 445, zaharuri: 27.5, sare: 22.5 },
    image: "platou-gratar", available: true,
  },
  {
    category: "mancare", subcategory: "platouri", name: "Platou Boieresc", price: 240, weight: "2,5 kg", weightGrams: 2500,
    ingredients: "Cartofi pai, nuggets pui, crispy, cartofi țărănești, chiflă, inele de ceapă, mozzarella sticks, maioneză, ketchup dulce",
    additives: ["Acid citric (E330)", "Sorbat de potasiu (E202)", "Benzoat de sodiu (E211)"],
    allergens: ["Gluten", "Ouă", "Lapte"], traces: ["Gluten", "Ouă", "Lapte"],
    nutritionPer100g: { kcal: 222.4, proteine: 8.3, grasimi: 12.1, saturate: 1.8, glucide: 27, zaharuri: 1.4, sare: 0.8 },
    nutritionPerServing: { kcal: 5560, proteine: 207.5, grasimi: 302.5, saturate: 45, glucide: 675, zaharuri: 35, sare: 20 },
    image: "platou-boieresc", available: true,
  },
  {
    category: "mancare", subcategory: "platouri", name: "Platou de Post", price: 240, weight: "2,5 kg", weightGrams: 2500,
    ingredients: "Cartofi pai, cartofi țărănești, chiftele vegetale, nuggets vegetal, inele de ceapă, pachețele de primăvară, castraveți murați, chiflă, maioneză, ketchup dulce",
    additives: ["Clorură de calciu (E509)", "Acid citric (E330)", "Sorbat de potasiu (E202)", "Benzoat de sodiu (E211)"],
    allergens: ["Gluten", "Ouă", "Lapte", "Muștar"], traces: ["Gluten", "Ouă"],
    nutritionPer100g: { kcal: 225.2, proteine: 5.8, grasimi: 11.3, saturate: 1.1, glucide: 23.9, zaharuri: 1.4, sare: 0.8 },
    nutritionPerServing: { kcal: 5630, proteine: 145, grasimi: 282.5, saturate: 27.5, glucide: 597.5, zaharuri: 35, sare: 20 },
    postOnly: true, image: "platou-post", available: true,
  },

  // ——— MÂNCARE / GARNITURI ———
  {
    category: "mancare", subcategory: "garnituri", name: "Porție cartofi pai", price: 8, weight: "200 g", weightGrams: 250,
    ingredients: "Cartofi pai",
    additives: [], allergens: [], traces: [],
    nutritionPer100g: { kcal: 319, proteine: 4, grasimi: 17, saturate: 0, glucide: 38, zaharuri: 0, sare: 1 },
    nutritionPerServing: { kcal: 797.5, proteine: 10, grasimi: 42.5, saturate: 0, glucide: 95, zaharuri: 0, sare: 2.5 },
    image: null, available: true,
  },
  {
    category: "mancare", subcategory: "garnituri", name: "Porție cartofi țărănești", price: 9, weight: "200 g", weightGrams: 250,
    ingredients: "Cartofi țărănești",
    additives: [], allergens: [], traces: [],
    nutritionPer100g: { kcal: 124, proteine: 5, grasimi: 6, saturate: 1, glucide: 14, zaharuri: 0, sare: 0 },
    nutritionPerServing: { kcal: 310, proteine: 12.5, grasimi: 15, saturate: 2.5, glucide: 35, zaharuri: 0, sare: 0 },
    image: null, available: true,
  },

  // ——— BĂUTURI / RĂCORITOARE ———
  { category: "bauturi", subcategory: "racoritoare", name: "Vitamin Aqua", volume: "600 ml", price: 10, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Limonadă", volume: "600 ml", price: 10, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Fanta", volume: "330 ml", flavors: "struguri / portocale", price: 7, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Sprite", volume: "330 ml", price: 7, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Coca-Cola", volume: "330 ml", price: 7, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Coca-Cola sticlă", volume: "330 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Aloe Vera", volume: "240 ml", price: 7, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Tedi Go", volume: "330 ml", price: 7, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Tedi pai", volume: "250 ml", price: 6, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Hell", volume: "250 ml", price: 6, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Red Bull", volume: "250 ml", price: 9, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Monster", volume: "500 ml", price: 10, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Fanta", volume: "500 ml", flavors: "struguri / portocale / tropical", price: 8, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Coca-Cola", volume: "500 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Aloe Vera", volume: "500 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Mountain Dew", volume: "500 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Schweppes", volume: "500 ml", flavors: "mandarin / tonic / lemon", price: 8, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Fuzetea", volume: "500 ml", flavors: "piersică / lămâie / fructe de pădure", price: 8, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Tymbark cheiță", volume: "250 ml", price: 6, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Apă plată", volume: "500 ml", price: 5, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Apă minerală", volume: "500 ml", price: 5, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Apă plată", volume: "750 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Apă minerală", volume: "750 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Apă fructată", volume: "500 ml", price: 6, available: true },
  { category: "bauturi", subcategory: "racoritoare", name: "Prigat", volume: "500 ml", price: 8, available: true },

  // ——— BĂUTURI / BERE ———
  { category: "bauturi", subcategory: "bere", group: "La halbă / draft", name: "Tuborg / Skol draft", volume: "300 ml", price: 6, available: true },
  { category: "bauturi", subcategory: "bere", group: "La halbă / draft", name: "Tuborg / Skol draft", volume: "400 ml", price: 7, available: true },
  { category: "bauturi", subcategory: "bere", group: "Bere 750 ml", name: "Tuborg", volume: "750 ml", price: 10, available: true },
  { category: "bauturi", subcategory: "bere", group: "Bere 500 ml — alcool", name: "Suceava", volume: "500 ml", price: 5, available: true },
  { category: "bauturi", subcategory: "bere", group: "Bere 500 ml — alcool", name: "Tuborg", volume: "500 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "bere", group: "Bere 500 ml — alcool", name: "Timișoreana", volume: "500 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "bere", group: "Bere 500 ml — alcool", name: "Ciucaș", volume: "500 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "bere", group: "Bere 500 ml — alcool", name: "Bergenbier", volume: "500 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "bere", group: "Bere 500 ml — alcool", name: "Ursus", volume: "500 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "bere", group: "Bere 500 ml — fără alcool", name: "Ursus Cooler", volume: "500 ml", flavors: "diferite arome", price: 8, available: true },
  { category: "bauturi", subcategory: "bere", group: "Bere 500 ml — fără alcool", name: "Ursus", volume: "500 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "bere", group: "Bere 500 ml — fără alcool", name: "Tuborg", volume: "500 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "bere", group: "Bere 330 ml — alcool", name: "Peroni", volume: "330 ml", price: 9, available: true },
  { category: "bauturi", subcategory: "bere", group: "Bere 330 ml — alcool", name: "Tuborg", volume: "330 ml", price: 7, available: true },
  { category: "bauturi", subcategory: "bere", group: "Bere 330 ml — alcool", name: "Ursus", volume: "330 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "bere", group: "Bere 330 ml — alcool", name: "Corona Extra", volume: "330 ml", price: 10, available: true },
  { category: "bauturi", subcategory: "bere", group: "Bere 330 ml — fără alcool", name: "Ursus Cooler fructat", volume: "330 ml", flavors: "diferite arome", price: 7, available: true },
  { category: "bauturi", subcategory: "bere", group: "Bere 330 ml — fără alcool", name: "Tuborg", volume: "330 ml", price: 7, available: true },
  { category: "bauturi", subcategory: "bere", group: "Bere 330 ml — fără alcool", name: "Ursus", volume: "330 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "bere", group: "Bere 330 ml — fără alcool", name: "Peroni", volume: "330 ml", price: 9, available: true },

  // ——— BĂUTURI / COFFEE ———
  { category: "bauturi", subcategory: "coffee", name: "Espresso scurt", volume: "30 ml", price: 7, available: true },
  { category: "bauturi", subcategory: "coffee", name: "Espresso lung", volume: "60 ml", price: 7, available: true },
  { category: "bauturi", subcategory: "coffee", name: "Cafea cu lapte", volume: "200 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "coffee", name: "Ciocolată caldă", volume: "200 ml", flavors: "albă / neagră", price: 12, available: true },
  { category: "bauturi", subcategory: "coffee", name: "Cappuccino", volume: "200 ml", price: 9, available: true },
  { category: "bauturi", subcategory: "coffee", name: "Ice Coffee", volume: "300 ml", price: 12, available: true },
  { category: "bauturi", subcategory: "coffee", name: "Frappé cald / rece", volume: "350 ml", price: 14, available: true },
  { category: "bauturi", subcategory: "coffee", name: "Ceai", volume: "200 ml", flavors: "fructe de pădure / fructe tropicale / mușețel și miere / mentă / ghimbir", price: 7, available: true },
  { category: "bauturi", subcategory: "coffee", name: "Ice Tea", volume: "300 ml", flavors: "piersică / mango / lămâie", price: 12, available: true },

  // ——— BĂUTURI / LIMONADE & FRESH ———
  { category: "bauturi", subcategory: "limonade", name: "Limonadă", volume: "350 ml", flavors: "simplă / căpșuni / mango / zmeură / kiwi / fructul pasiunii / măr", price: 14, available: true },
  { category: "bauturi", subcategory: "limonade", name: "Fresh", volume: "350 ml", flavors: "portocale / grepfrut / mixt", price: 14, available: true },

  // ——— BĂUTURI / BĂUTURI ALCOOLICE ———
  { category: "bauturi", subcategory: "alcoolice", name: "Jack Daniel's", volume: "50 ml", price: 11, available: true },
  { category: "bauturi", subcategory: "alcoolice", name: "Voronskaya", volume: "50 ml", price: 5, available: true },
  { category: "bauturi", subcategory: "alcoolice", name: "Stalinskaya", volume: "50 ml", price: 7, available: true },
  { category: "bauturi", subcategory: "alcoolice", name: "Absolut Vodka", volume: "50 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "alcoolice", name: "Ballantine's", volume: "50 ml", price: 11, available: true },
  { category: "bauturi", subcategory: "alcoolice", name: "Sheridan's", volume: "50 ml", price: 13, available: true },
  { category: "bauturi", subcategory: "alcoolice", name: "Jägermeister", volume: "50 ml", price: 10, available: true },
  { category: "bauturi", subcategory: "alcoolice", name: "Finlandia", volume: "50 ml", price: 7, available: true },
  { category: "bauturi", subcategory: "alcoolice", name: "J&B", volume: "50 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "alcoolice", name: "Jameson", volume: "50 ml", price: 11, available: true },
  { category: "bauturi", subcategory: "alcoolice", name: "Alexandrion", volume: "50 ml", price: 8, available: true },
  { category: "bauturi", subcategory: "alcoolice", name: "Angelli", volume: "50 ml", price: 4, available: true },
  { category: "bauturi", subcategory: "alcoolice", name: "Cinzano", volume: "50 ml", price: 7, available: true },
  { category: "bauturi", subcategory: "alcoolice", name: "Aperol", volume: "50 ml", price: 9, available: true },
  { category: "bauturi", subcategory: "alcoolice", name: "Vorona / V33", volume: "50 ml", price: 4, available: true },
  { category: "bauturi", subcategory: "alcoolice", name: "Havana Club", volume: "50 ml", price: 8, available: true },

  // ——— BĂUTURI / VIN ———
  { category: "bauturi", subcategory: "vin", group: "Carafă 1 litru", name: "Recaș alb sec", volume: "1 l", price: 25, available: true },
  { category: "bauturi", subcategory: "vin", group: "Carafă 1 litru", name: "Recaș roze demidulce", volume: "1 l", price: 25, available: true },
  { category: "bauturi", subcategory: "vin", group: "Pahar 200 ml", name: "Recaș alb sec", volume: "200 ml", price: 7, available: true },
  { category: "bauturi", subcategory: "vin", group: "Pahar 200 ml", name: "Recaș roze demidulce", volume: "200 ml", price: 7, available: true },
  { category: "bauturi", subcategory: "vin", group: "Sticlă 750 ml", name: "Purcari alb sec", volume: "750 ml", price: 50, available: true },
  { category: "bauturi", subcategory: "vin", group: "Sticlă 750 ml", name: "Jidvei alb demisec", volume: "750 ml", price: 40, available: true },
  { category: "bauturi", subcategory: "vin", group: "Sticlă 750 ml", name: "Riunite Lambrusco", volume: "750 ml", price: 40, available: true },
  { category: "bauturi", subcategory: "vin", group: "Sticlă 750 ml", name: "Castel Huniade roze demisec", volume: "750 ml", price: 38, available: true },
  { category: "bauturi", subcategory: "vin", group: "Sticlă 750 ml", name: "Recaș alb sec", volume: "750 ml", price: 35, available: true },
  { category: "bauturi", subcategory: "vin", group: "Sticlă 750 ml", name: "Recaș roze demidulce", volume: "750 ml", price: 35, available: true },
  { category: "bauturi", subcategory: "vin", group: "Sticlă 750 ml", name: "Cotnari alb demidulce", volume: "750 ml", price: 26, available: true },
  { category: "bauturi", subcategory: "vin", group: "Sticlă 750 ml", name: "Cotnari alb demisec", volume: "750 ml", price: 26, available: true },

  // ——— BĂUTURI / ȘAMPANIE ———
  { category: "bauturi", subcategory: "sampanie", name: "Mionetto Prosecco Rosé", volume: "750 ml", price: 50, available: true },
  { category: "bauturi", subcategory: "sampanie", name: "Angelli piersică", volume: "750 ml", price: 35, available: true },
  { category: "bauturi", subcategory: "sampanie", name: "Zarea demisec", volume: "750 ml", price: 35, available: true },
  { category: "bauturi", subcategory: "sampanie", name: "Robby Bubble", volume: "750 ml", flavors: "fără alcool", price: 25, available: true },

  // ——— DESERT ———
  {
    category: "desert", name: "Lava Cake", price: 30, weight: "180 g", weightGrams: 180,
    ingredients: "Înghețată, frișcă, topping, brioșă de ciocolată",
    additives: ["Caragenan (E407)"],
    allergens: ["Gluten", "Ouă", "Lapte"], traces: ["Lapte"],
    nutritionPer100g: { kcal: 285.8, proteine: 4.8, grasimi: 18.2, saturate: 9.3, glucide: 34, zaharuri: 22.6, sare: 0 },
    nutritionPerServing: { kcal: 514.4, proteine: 8.6, grasimi: 32.8, saturate: 16.7, glucide: 61.2, zaharuri: 40.7, sare: 0 },
    image: "lava-cake", available: true,
  },
  {
    category: "desert", name: "Gogoși", price: 6, weight: "80 g", weightGrams: 80,
    additives: [], allergens: ["Gluten", "Ouă", "Lapte"], traces: [],
    nutritionPer100g: { kcal: 214.9, proteine: 7.2, grasimi: 19, saturate: 8.4, glucide: 41.2, zaharuri: 30.2, sare: 0 },
    nutritionPerServing: { kcal: 171.9, proteine: 5.8, grasimi: 15.2, saturate: 6.7, glucide: 33, zaharuri: 24.2, sare: 0 },
    image: "gogosi", available: true,
  },
  { category: "desert", name: "Gogoși ciocolată", price: 6, available: true },
  { category: "desert", name: "Gogoși Glazurate", price: 6, image: "gogosi-glazurate", available: true },
  { category: "desert", name: "Brioșe afine / ciocolată", price: 8, available: true },
  { category: "desert", name: "Cipsuri (Chio / Lays)", price: 12, weight: "125 g", available: true },
  { category: "desert", name: "Popcorn sare / cașcaval", price: 7, weight: "75 g", available: true },
  { category: "desert", name: "Înghețată Betty Ice", flavors: "diverse sortimente", available: true },

  // ——— EXTRA ———
  { category: "extra", name: "Castraveți murați", weight: "50 g", price: 4, available: true },
  { category: "extra", name: "Chiflă", weight: "65 g", price: 4, available: true },
  { category: "extra", name: "Extra carne", weight: "50 g", price: 5, available: true },
  { category: "extra", name: "Extra cașcaval", weight: "50 g", price: 5, available: true },
  { category: "extra", name: "Extra porumb", weight: "50 g", price: 5, available: true },
  { category: "extra", name: "Extra lapte", volume: "30 ml", price: 1, available: true },
  { category: "extra", name: "Lapte vegetal", volume: "30 ml", price: 1, available: true },
  { category: "extra", name: "Extra topping cafea", volume: "20 ml", price: 3, available: true },
  { category: "extra", name: "Extra sos", volume: "50 ml", flavors: "dulce / maioneză / usturoi / picant / muștar", price: 3, available: true },
  { category: "extra", name: "Sos cheddar", volume: "50 ml", price: 5, available: true },
];

// Helpers
export const formatPrice = (price) => {
  if (price === null || price === undefined) return null;
  return `${price} ${price === 1 ? "leu" : "lei"}`;
};

// Ancora de scroll pentru o secțiune: prima subcategorie sau secțiunea în sine.
export const sectionAnchor = (section) =>
  section.subcategories && section.subcategories.length
    ? `sub-${section.subcategories[0].id}`
    : `sec-${section.id}`;

export const productsFor = (category, subcategory) =>  PRODUCTS.filter(
    (p) => p.category === category && (subcategory ? p.subcategory === subcategory : true)
  );

// Grupare pe câmpul opțional "group", păstrând ordinea de apariție
export const groupProducts = (items) => {
  const groups = [];
  const map = new Map();
  for (const item of items) {
    const key = item.group || "";
    if (!map.has(key)) {
      const g = { label: item.group || null, items: [] };
      map.set(key, g);
      groups.push(g);
    }
    map.get(key).items.push(item);
  }
  return groups;
};
